export default __webpack_public_path__ + "static/media/union-2.3f82f655.svg";